var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoAdmin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 422.711,
    height: 98.392,
    viewBox: "0 0 422.711 98.392",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo.admin",
    transform: "translate(-146.9 -223.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(146.9 223.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M181.1,18.254V51.823h-8.132V26.952a108.242,108.242,0,0,1,8.132-8.7Z",
    transform: "translate(142.185 15.005)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M200.263,19.586A15.083,15.083,0,0,1,215.51,34.465a14.611,14.611,0,0,1-4.46,10.526,15.341,15.341,0,0,1-10.786,4.362H189.077V22.01q1.766-1.266,3.566-2.423h7.614m0-7.744h-9.934a94.088,94.088,0,0,0-9.176,6.35v38.9h19.109a23.393,23.393,0,0,0,16.4-6.63,22.3,22.3,0,0,0,6.783-16,22.9,22.9,0,0,0-23.178-22.622Z",
    transform: "translate(148.909 9.734)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M152.341,66.828V21.576H161.1l13.968,21.015c19.3-26.8,64.635-57.769,122.411-34.256,0,0-76.19-29.2-122.664,47.4l-14.6-22.243V66.837Z",
    transform: "translate(125.229 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M0,11.842H31.722V17.9h-12.1v39.2H12.166V17.9H0Z",
    transform: "translate(0 9.734)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M19.744,11.842H27.2V25.387a14.316,14.316,0,0,1,11.184-4.754c8.046,0,14.325,5.273,14.325,15.305V57.094H45.318V37.041c0-6.576-3.6-9.963-9.026-9.963-5.493,0-9.09,3.387-9.09,9.963V57.094H19.744Z",
    transform: "translate(16.23 9.734)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M57.871,53.128c-10.335,0-17.987-6.705-17.987-17.969s7.325-18.492,17.987-18.492c10.267,0,17.528,7.106,17.528,17.645a22.728,22.728,0,0,1-.262,3.644H47.6a9.9,9.9,0,0,0,10.271,9.506,8.729,8.729,0,0,0,8.5-5.012h8.044C72.391,48.7,66.7,53.128,57.871,53.128Zm-10.2-21.161h19.94c-.131-5.534-4.513-9.05-10.072-9.05a9.8,9.8,0,0,0-9.87,9.05Z",
    transform: "translate(32.786 13.701)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M91,11.524c9.485,0,17.661,4.752,21.136,13.607h-8.964A12.709,12.709,0,0,0,91,18.045c-9.025,0-15.566,6.377-15.566,16.6S81.977,51.315,91,51.315a12.709,12.709,0,0,0,12.166-7.106h8.961c-3.462,8.855-11.641,13.151-21.136,13.151-12.818,0-23.218-9.11-23.218-22.723A22.686,22.686,0,0,1,91,11.524Z",
    transform: "translate(55.709 9.468)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M110.737,16.67a15.367,15.367,0,0,1,12.494,5.794V17.255h7.521V53.131h-7.521V47.792c-2.288,3.061-6.607,5.339-12.625,5.339-9.352,0-16.874-7.031-16.874-18.1S101.253,16.67,110.737,16.67Zm1.571,6.445c-5.559,0-10.932,4.167-10.932,11.916s5.364,12.24,10.932,12.24c5.625,0,10.923-4.362,10.923-12.109,0-7.682-5.3-12.055-10.923-12.055Z",
    transform: "translate(77.05 13.698)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M125.1,53.136h-7.456V17.26H125.1v5.209a11.752,11.752,0,0,1,10.792-5.794v7.682h-1.9c-5.493,0-8.9,2.279-8.9,9.9Z",
    transform: "translate(96.704 13.693)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M146.252,53.128c-10.333,0-17.985-6.705-17.985-17.969s7.325-18.492,17.985-18.492c10.269,0,17.53,7.106,17.53,17.645a22.727,22.727,0,0,1-.262,3.644H135.98a9.9,9.9,0,0,0,10.269,9.506,8.731,8.731,0,0,0,8.5-5.012H162.8C160.772,48.7,155.082,53.128,146.252,53.128Zm-10.2-21.161H156c-.131-5.534-4.513-9.05-10.072-9.05a9.8,9.8,0,0,0-9.877,9.05Z",
    transform: "translate(105.439 13.701)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(172.855 304.103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M16.574,53.81v8.135H14.245V44.113h2.329v8.265l7.368-8.265h2.944L18.8,53.041l8.165,8.9H23.918Z",
    transform: "translate(-14.245 -43.891)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M35.766,46.017H28.5v5.962H35V53.9H28.5v6.142h7.268v1.917h-9.6V44.1h9.6Z",
    transform: "translate(-4.443 -43.902)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M46.48,46.017H39.214v5.962h6.5V53.9h-6.5v6.142H46.48v1.917H36.885V44.1H46.48Z",
    transform: "translate(4.366 -43.902)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M53.358,54.5H49.929v7.445H47.6V44.113h5.758c4.191,0,6.168,2.3,6.168,5.22C59.525,52.044,57.785,54.5,53.358,54.5Zm0-1.919c2.662,0,3.788-1.254,3.788-3.249,0-2.073-1.126-3.3-3.788-3.3H49.929v6.559Z",
    transform: "translate(13.252 -43.891)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M59.243,44.113h2.329V61.945H59.243Z",
    transform: "translate(22.849 -43.891)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M80.222,44.1V61.956H77.9L68.538,47.744V61.956H66.209V44.1h2.329L77.9,58.277V44.1Z",
    transform: "translate(28.595 -43.902)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M96.345,49.38H93.554A5.688,5.688,0,0,0,88.13,46.1a6.477,6.477,0,0,0-6.576,7.017A6.468,6.468,0,0,0,88.13,60.1,6.013,6.013,0,0,0,94.4,54.32H87.293V52.427h9.6v1.784a8.651,8.651,0,0,1-8.746,7.984,9.1,9.1,0,1,1,0-18.2A8.434,8.434,0,0,1,96.345,49.38Z",
    transform: "translate(39.179 -43.991)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M100.478,44.113h2.591l4.4,9.032,4.4-9.032h2.585l-5.809,11.114v6.718h-2.336V55.218Z",
    transform: "translate(56.847 -43.891)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M121.622,62.22a9.11,9.11,0,1,1,8.957-9.11,8.8,8.8,0,0,1-8.957,9.11Zm0-2.021a6.516,6.516,0,0,0,6.577-7.09,6.6,6.6,0,1,0-13.153,0,6.516,6.516,0,0,0,6.576,7.09Z",
    transform: "translate(66.644 -43.984)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M127.528,44.113h2.33V55.4c0,3.28,1.766,4.683,4.4,4.683s4.373-1.407,4.373-4.683V44.113h2.33V55.371a6.718,6.718,0,0,1-13.436,0Z",
    transform: "translate(79.145 -43.891)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M147.049,44.113h2.482l3.89,15.123,4.3-15.123h2.609l4.094,15.072,3.916-15.072h2.507l-5.169,17.832h-2.609l-4.147-14.356-4.3,14.356-2.585.026Z",
    transform: "translate(95.252 -43.891)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M174.626,46.017h-7.275v5.962h6.5V53.9h-6.5v6.142h7.268v1.917h-9.6V44.1h9.6Z",
    transform: "translate(110.099 -43.902)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M178.071,44.113V60.054h6.244v1.891h-8.573V44.113Z",
    transform: "translate(118.911 -43.891)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M187.646,44.113V60.054h6.244v1.891h-8.564V44.113Z",
    transform: "translate(126.79 -43.891)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAdmin);
export default __webpack_public_path__ + "static/media/logoAdmin.94833b93a9e28e7a7bfdbcdc2da4d624.svg";
export { ForwardRef as ReactComponent };